export const environment = {
  production: true,
  hmr: false,
  apiUrl: 'http://10care-development-env.eba-8vxnek4z.us-east-1.elasticbeanstalk.com'
};
